
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/repayment_calculator",
      function () {
        return require("private-next-pages/repayment_calculator.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/repayment_calculator"])
      });
    }
  